import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";
import ReviewRequirements from "./ReviewRequirements";
import SelectCertifications from "./SelectCertifications";
import TermsAndAttestation from "./TermsAndAttestation";
import { deepCopy } from "../../Shared/Utility/DeepCopy";
import AbpnSpinner from "../../Shared/Components/AbpnSpinner";
import CcAssessmentPathwayEnrollment, { CcAssessmentPathwayEnrollmentCertificate } from "../Models/CcAssessmentPathwayEnrollment";
import Physician from "../../Physician/Models/Physician";
import { abpnClient } from "../../../Services/AbpnClient";
import { AuthContext } from "../../Auth/AuthProvider";
import UpdateCCAssessmentPathwayModel from "../Models/UpdateCCAssessmentPathwayModel";

interface INavigation {
    sectionsComplete: number,
    activeSections: Array<EnrollmentSection>,
}

enum EnrollmentSection {
    Certifications,
    Requirements,
    Terms
}


export default function ManageCCEnrollment(){
    const [physician, setPhysician] = useState<Physician>(null);
    const [sectionNavigation, setSectionNav] = useState<INavigation>({sectionsComplete: null, activeSections: null});
    const [loading, setLoading] = useState<boolean>(true);
    const authContext = useContext(AuthContext);
    const [pathwayEnrollment, setPathwayEnrollment] = useState<CcAssessmentPathwayEnrollment>(new CcAssessmentPathwayEnrollment());

    useEffect(() => {
        abpnClient.get<Physician>("/api/physician", authContext)
                .then(physician => {
                    setPhysician(physician);
                    
                    abpnClient.get<CcAssessmentPathwayEnrollment>("/api/physician/GetCCAssessmentPathwayEnrollment", authContext)
                        .then (enrollment => {
                            setPathwayEnrollment(enrollment);
                            console.log(enrollment);
                            let activeSections = [EnrollmentSection.Certifications];
                            activeSections.push(EnrollmentSection.Requirements);
                            activeSections.push(EnrollmentSection.Terms);
                            var updated = deepCopy(sectionNavigation);
                            updated.activeSections = activeSections;
                            updated.sectionsComplete = 0;

                            setSectionNav(updated);
                            setLoading(false);
                        })
                });
    }, []);

    const updateSectionsComplete = (index: number) => {
        var updatedNav = deepCopy(sectionNavigation);
        updatedNav.sectionsComplete = index;
        setSectionNav(updatedNav);
    }

    const previousSectionComplete = (section: EnrollmentSection) => {
        return (sectionNavigation.sectionsComplete === sectionNavigation.activeSections.indexOf(section));
    }

    const onSelectCertificationsContinue = () => {
        // Move to next section
        
        var enrolledcCertificates = pathwayEnrollment.ccEnrollmentCertificates.filter(_ => _.isEnrolled === true);
        if (enrolledcCertificates.length === 0){
            updateSectionsComplete(sectionNavigation.sectionsComplete + 2);
        }else{
            updateSectionsComplete(sectionNavigation.sectionsComplete + 1);
        }
        
    }

    const onUpdatedCertificates = (certificates: Array<CcAssessmentPathwayEnrollmentCertificate>) => {
        var updated = deepCopy(pathwayEnrollment);
        updated.ccEnrollmentCertificates = certificates
        setPathwayEnrollment(updated);
    }

    const onReviewRequirementsContinue = () => {
        // Move to next section
        updateSectionsComplete(sectionNavigation.sectionsComplete + 1);
    }

    const onReviewRequirementsPrevious = () => {
        // Move to next section
        updateSectionsComplete(sectionNavigation.sectionsComplete - 1);
    }

    const history = useHistory();

    

    const onTermsCompleteEnrollment = async () => {
        const url = "/api/Physician/UpdateCCAssessmentPathwayEnrollment";
        var dto = new UpdateCCAssessmentPathwayModel(pathwayEnrollment);
            await abpnClient.post<CcAssessmentPathwayEnrollment>(url, dto, authContext).then(result => {
                setPathwayEnrollment(result);
            });

        history.push('/');

    }

    const onTermsPrevious = () => {
        // Move to next section
        var enrolledcCertificates = pathwayEnrollment.ccEnrollmentCertificates.filter(_ => _.isEnrolled === true);
        if (enrolledcCertificates.length === 0){
            updateSectionsComplete(sectionNavigation.sectionsComplete - 2);
        }else{
            updateSectionsComplete(sectionNavigation.sectionsComplete - 1);
        }
        
    }

    const isSectionDisabled = (section: EnrollmentSection) => {
        return  (sectionNavigation.sectionsComplete !== sectionNavigation.activeSections.indexOf(section));
    }

    const onCancel = () => {
        history.push('/');
    }

    if (!(sectionNavigation.activeSections)) return <AbpnSpinner></AbpnSpinner>
    return (
        <Container>
            <Row>
                <Col>
                <div className="ml-3 mr-3" >
                    <h3 className="mb-3 text-pp-secondary font-weight-bold">Manage CC Enrollment</h3>
                    <SelectCertifications 
                        disabled={isSectionDisabled(EnrollmentSection.Certifications)} 
                        isSectionOpen={previousSectionComplete(EnrollmentSection.Certifications)}
                        onOpen={() => updateSectionsComplete(0)}
                        isLoading={loading}
                        onContinue={onSelectCertificationsContinue}
                        certificates={pathwayEnrollment && pathwayEnrollment.ccEnrollmentCertificates}
                        updateCertificates={onUpdatedCertificates}
                    />
                    <ReviewRequirements 
                        disabled={isSectionDisabled(EnrollmentSection.Requirements)} 
                        isSectionOpen={previousSectionComplete(EnrollmentSection.Requirements)}
                        onOpen={() => updateSectionsComplete(sectionNavigation.activeSections.indexOf(EnrollmentSection.Requirements))}
                        isLoading={loading} 
                        onContinue={onReviewRequirementsContinue}
                        onPrevious={onReviewRequirementsPrevious}
                        currentEnrollment={physician.currentCCEnrollment}
                        pathwayEnrollment={pathwayEnrollment}
                        />
                    <TermsAndAttestation disabled={isSectionDisabled(EnrollmentSection.Terms)} 
                        isSectionOpen={previousSectionComplete(EnrollmentSection.Terms)}
                        onOpen={() => updateSectionsComplete(sectionNavigation.activeSections.indexOf(EnrollmentSection.Terms))}
                        isLoading={loading}
                        onCompleteEnrollment={onTermsCompleteEnrollment}
                        pathwayEnrollment={pathwayEnrollment}
                        onPrevious={onTermsPrevious}
                        updateCertificates={onUpdatedCertificates}
                        />
                        <Button type="button" variant="outline-pp-primary" onClick={onCancel}>Cancel</Button>                                    
                </div>
                </Col>
            </Row>
        </Container >
    )
}


